module.exports = __webpack_public_path__ + "0b6cdd15dcab7f9ea51ddf74fd7dd48c.pdf";